// extracted by mini-css-extract-plugin
module.exports = {"filterElSize":"consumption_filterElSize__18H1v","filter":"consumption_filter__3Hgu3","comsumptionPage":"consumption_comsumptionPage__17lI7"};